export var SHOPGATE_CATALOG_GET_SEARCH_SUGGESTIONS='shopgate.catalog.getSearchSuggestions';